import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { SwiperModule } from 'swiper/angular';

import { indicateLoading } from '@app/@core/helpers';
import { RafflesState } from '@app/modules/raffles/raffles.state';

import RaffleItemBannerComponent from '../raffle-item/raffle-item.component';

@Component({
  selector: 'raffles-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'h-full' },
  imports: [
    RouterLink,
    RaffleItemBannerComponent,
    SwiperModule
  ]
}) 
export default class RafflesBannerComponent implements OnInit {
  public readonly rafflesState = inject(RafflesState);
  private readonly destroyRef = inject(DestroyRef);
  public readonly isLoading = signal<boolean>(false);

  ngOnInit(): void {
    this.rafflesState.load()
      .pipe(
        indicateLoading(this.isLoading),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
